module.exports = "<app-navigation (refresh)=\"refresh($event)\">Loading...</app-navigation>\r\n"